import { useState } from "react";
import { api, day } from "../../api.js";
import { newRow } from "../../../../lib/pn/model.js";
import { DOC_TYPES, filledLines } from "../../../../lib/primary/model.js";
import { kopUi } from "../../../../lib/pn/calc.js";

// Позиції з первинного документа цього покупця (видаткова, акт, рахунок, складені в eCabinet): рядки — та сама модель,
// що в ПН, тож переносяться як є; документ і ПН заразом пов'язуються (документ підтверджує ПН)
const TYPES = ["waybill", "act", "invoice"];

export default function PnFromPrimary({ companyId, draftId, doc, update }) {
  const [list, setList] = useState(null), [busy, setBusy] = useState(null), [error, setError] = useState(null), [done, setDone] = useState(null);
  const tin = doc.buyer?.tin;
  if (!tin) return null;
  const load = async () => {
    setError(null); setDone(null);
    try {
      const r = await api(`/api/companies/${companyId}/primary/documents?dir=sale&q=${encodeURIComponent(tin)}`);
      setList(r.documents.filter((d) => TYPES.includes(d.type) && d.origin === "generated" && d.counterpartyTin === tin));
    } catch (e) { setError(e.message); }
  };
  const take = async (d) => {
    setBusy(d.id); setError(null);
    try {
      const base = `/api/companies/${companyId}/primary/documents/${d.id}`;
      const r = await api(base), label = `${DOC_TYPES[d.type].short.toLowerCase()} № ${d.number}`;
      const rows = filledLines(r.snapshot?.lines).map(({ id, ...x }) => newRow({ ...x, source: `з ${label}` }));
      if (!rows.length) throw new Error("У документі немає позицій");
      const has = doc.rows.filter((x) => x.name.trim()).length;
      if (has && !window.confirm(`Замінити ${has} позицій ПН позиціями з ${label} (${rows.length})?`)) { setBusy(null); return; }
      update((x) => ({ ...x, rows, priceMode: r.snapshot.priceMode || x.priceMode }));
      await api(`${base}/pn-links`, { method: "POST", body: { pnDraftId: draftId } });
      setList(null); setDone(`Підставлено ${rows.length} позицій з ${label}; документ пов'язано з цією ПН.`);
    } catch (e) { setError(e.message); }
    setBusy(null);
  };
  return (
    <section className="card pn-from-primary" aria-labelledby="pn-from-primary-h">
      <h3 id="pn-from-primary-h" className="small">Позиції з первинного документа</h3>
      {!list && <button type="button" className="btn btn-sm btn-secondary" onClick={load}>Вибрати видаткову, акт чи рахунок покупця</button>}
      {list && (list.length ? (
        <ul className="primary-docs">{list.map((d) => (
          <li key={d.id}>{DOC_TYPES[d.type].short} № {d.number}{d.date ? ` від ${day(d.date)}` : ""}{d.total != null ? ` · ${kopUi(BigInt(d.total))} грн` : ""}
            {d.status === "draft" ? " · чернетка" : d.status === "cancelled" ? " · скасовано" : ""}
            <button type="button" className="btn btn-sm" disabled={Boolean(busy)} onClick={() => take(d)}>{busy === d.id ? "Підставляємо…" : "Підставити"}</button></li>))}</ul>
      ) : <p className="muted small">Документів цього покупця в «Первинних документах» немає. <a href={`#/c/${companyId}/primary/docs`}>Первинні документи →</a></p>)}
      {done && <p className="notice small" role="status">{done}</p>}
      {error && <p className="error" role="alert">{error}</p>}
    </section>
  );
}
